import styled from "@emotion/styled";
import { MediaMetadataGridContainer, MediaMetadataGridItem } from "../grid/MediaMetadataGrid";
import { Box } from "@mediaspace/shared/styled";
import { KmsTypePresenter } from "@mediaspace/shared/types";
import { Presenter } from "../../presenter/Presenter";

export interface MetadataPresentersProps {
    id: string;
    presenters: KmsTypePresenter[];
}

const staticClassBase = "kms-ds-media-page-metadata-presenters";

const StyledPresenters = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

/**
 * media page metadata presenters
 */
export const MetadataPresenters = (props: MetadataPresentersProps) => {
    const { id, presenters } = { ...props };

    return (
        <StyledPresenters className={staticClassBase} id={id}>
            <MediaMetadataGridContainer
                rowSpacing={{ xl: 4, lg: 4, md: 4, sm: 4, xs: 2 }}
            >
                {presenters.map((presenter: KmsTypePresenter) => {
                    return (
                        <MediaMetadataGridItem key={"presenter" + presenter.id}>
                            <Presenter
                                data={presenter}
                                className={`${staticClassBase}-presenter`}
                            />
                        </MediaMetadataGridItem>
                    );
                })}
            </MediaMetadataGridContainer>
        </StyledPresenters>
    );
};

export default MetadataPresenters;
